import store from "@/store";

export const accountRoute = [
  {
    path: "personal",
    name: "personal",
    component: () =>
      import(
        /* webpackChunkName: "account" */ "@/components/AccountPage/Kyc/index"
      ),
    async beforeEnter(to, from, next) {
      const userVerifyInfo = store.getters.GET_USER_VERIFY_INFO;
      if (userVerifyInfo.kyc_step === "FULL_VERIFIED") {
        next({ name: "kycResult" });
      } else {
        next();
      }
    },
    redirect: "/account/personal/personalInformation",
    children: [
      // {
      //   path: "contact",
      //   name: "contact",
      //   component: () =>
      //     import(
      //       /* webpackChunkName: "contact" */ "@/components/AccountPage/Kyc/PersonalContact/index"
      //     ),
      //   async beforeEnter(to, from, next) {
      //     const userVerifyInfo = store.getters.GET_USER_VERIFY_INFO;
      //     if (
      //       to.name === "contact" &&
      //       userVerifyInfo.is_email_verified === true &&
      //       userVerifyInfo.is_mobile_verified === true
      //     ) {
      //       next({ name: "personalInformation" });
      //     } else {
      //       next();
      //     }
      //   }
      // },
      {
        path: "personalInformation",
        name: "personalInformation",
        component: () =>
          import(
            /* webpackChunkName: "personalInformation" */ "@/components/AccountPage/Kyc/PersonalInformation/index"
          ),
        async beforeEnter(to, from, next) {
          const userVerifyInfo = store.getters.GET_USER_VERIFY_INFO;
          if (
            userVerifyInfo.kyc_step === "USER_IDENTITY" ||
            userVerifyInfo.kyc_step === "USER_INFO_PROCESSING"
          ) {
            next({ name: "typeSelection" });
          } else {
            next();
          }
        }
      },
      {
        path: "autoKyc",
        name: "autoKyc",
        redirect: "autoKyc/typeSelection",
        component: () =>
          import(
            /* webpackChunkName: "autoKyc" */ "@/components/AccountPage/Kyc/AutoKyc/index"
          ),
        children: [
          {
            path: "typeSelection",
            name: "typeSelection",
            component: () =>
              import(
                /* webpackChunkName: "typeSelection" */ "@/components/AccountPage/Kyc/AutoKyc/KycTypeSelection/index"
              )
            // async beforeEnter(to, from, next) {
            //   const userVerifyInfo = store.getters.GET_USER_VERIFY_INFO;
            //
            //   if (
            //     !userVerifyInfo.is_id_card_verified &&
            //     !userVerifyInfo.is_video_verified
            //   )
            //     next();
            //   else next({ name: "internationalCard" });
            // }
          },
          // {
          //   path: "internationalCard",
          //   name: "internationalCard",
          //   component: () =>
          //     import(
          //       /* webpackChunkName: "internationalCard" */ "@/components/AccountPage/Kyc/AutoKyc/InternationalCard/index"
          //     ),
          //   async beforeEnter(to, from, next) {
          //     const userVerifyInfo = store.getters.GET_USER_VERIFY_INFO;
          //
          //     if (
          //       to.name === "internationalCard" &&
          //       userVerifyInfo.is_id_card_verified
          //     ) {
          //       next({ name: "video" });
          //     } else {
          //       next();
          //     }
          //   }
          // },
          {
            path: "video",
            name: "video",
            component: () =>
              import(
                /* webpackChunkName: "video" */ "@/components/AccountPage/Kyc/AutoKyc/VideoGuid/index"
              )
          }
        ]
      }
    ]
  },
  {
    path: "level",
    name: "level",
    component: () =>
      import(
        /* webpackChunkName: "Level" */ "@/components/AccountPage/Level/index"
      )
  },
  {
    path: "kycResult",
    name: "kycResult",
    component: () =>
      import(
        /* webpackChunkName: "kycResult" */ "@/components/AccountPage/Personal/index"
      )
  },
  {
    path: "banking",
    name: "banking",
    component: () =>
      import(
        /* webpackChunkName: "account" */ "@/components/AccountPage/Banking/index"
      )
  },
  {
    path: "security",
    name: "security",
    component: () =>
      import(
        /* webpackChunkName: "account" */ "@/components/AccountPage/Security/index"
      )
  }
];
